import React from 'react';

function Tunisia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123978)">
        <mask
          id="mask0_800_123978"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123978)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#E31D1C"
          />
          <mask
            id="mask1_800_123978"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_123978)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 20C22.9706 20 27 16.4183 27 12C27 7.58172 22.9706 4 18 4C13.0294 4 9 7.58172 9 12C9 16.4183 13.0294 20 18 20Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.5781 17.6508C19.5781 17.6508 14.8347 16.5005 14.8347 11.9735C14.8347 7.4465 19.5781 6.19756 19.5781 6.19756C17.6166 5.52276 11.8765 6.55814 11.8765 11.9735C11.8765 17.3888 17.7768 18.3641 19.5781 17.6508ZM19.317 10.9884L16.9636 11.7527L19.493 12.5386L19.5781 14.6435L21.1174 13.0082L23.6555 13.1684L21.8269 11.8422L22.9282 9.92713L20.7769 10.5708L19.2865 8.91486L19.317 10.9884Z"
              fill="#E31D1C"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123978">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Tunisia;
